export default function HighlightText(text, searchTerm) {

    if (!searchTerm || searchTerm.length === 0 || !text || text.length === 0) {
        return text;
    }
    const iQuery = new RegExp(searchTerm, "ig");

    return text.toString().replace(iQuery, function(matchedText) {
        return `<span class="highlight">${matchedText}</span>`;
    });
}
